import { apiClient } from "./http"

export interface NotificationUser {
  id: string
  email: string
  name: string
  profileImageUrl: string | null
  accountType: string
  role: string
  createdAt: string
  updatedAt: string
}

export interface NotificationItem {
  id: string
  userId: string
  type: string
  title: string
  body: string
  metadata: any
  isRead: boolean
  readAt: string | null
  createdAt: string
  updatedAt: string
  user?: NotificationUser
}

export interface GetNotificationsParams {
  page?: number
  limit?: number
  unreadOnly?: boolean
}

export interface GetNotificationsResponse {
  success: boolean
  statusCode: number
  message: string
  data: NotificationItem[]
  meta: {
    total: number
    page: number
    limit: number
    totalPages: number
  }
}

export interface UnreadCountResponse {
  success: boolean
  statusCode: number
  message: string
  data: number
}

export async function getNotifications(token: string, params: GetNotificationsParams = {}): Promise<GetNotificationsResponse> {
  const { data } = await apiClient.get("/notifications", {
    headers: { Authorization: `Bearer ${token}` },
    params,
  })
  return data
}

export async function getUnreadCount(token: string): Promise<UnreadCountResponse> {
  const { data } = await apiClient.get("/notifications/unread-count", {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function readAllNotifications(token: string): Promise<{ success: boolean }> {
  const { data } = await apiClient.patch("/notifications/read-all", {}, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}

export async function readNotification(token: string, id: string): Promise<{ success: boolean }> {
  const { data } = await apiClient.patch(`/notifications/${id}/read`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}
